import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import Footer from "./Footer";
import { useTranslation } from "react-i18next";
const Impressum = () => {
  const { t } = useTranslation("dashboard");
  return (
    <div className="ConstructionHome">
      <Header />
      <main className="main">
        <Hero compact />
        <section id="projects" className="projects section">
          <div className="container section-title" data-aos="fade-up">
            <h2>{t("Impressum")}</h2>
            <br />
            <div className="legal-text">
              <p>{t("Impressum")}</p>
              <br />
              <p>{t("Angaben gemäß § 5 TMG")}</p>
              <br />
              <p>{t("Monteursstandort")}</p>
              <br />
              <p>{t("Westring 255")}</p>
              <p>24116 Kiel</p>
              <p>(kein Ladengeschäft)</p>
              <br />
              <p>{t("Standorte Bereich")}</p>
              <p>{t("HL, KI, NMS, RD, RZ, OH, OD, NWM")}</p>
              <br />
              <p>{t("M. Ismail")}</p>
              <p>{t("Westring 255")}</p>
              <p>24116 Kiel</p>
              <p>(kein Ladengeschäft)</p>
              <br />
              <p>{t("Kontakt")}</p>
              <br />
              <p>{t("Telefon: 0151 - 72 54 62 46")}</p>
              <p>{t("Telefax: 0451 / 59 98 48 23")}</p>
              <p>{t("E-Mail: info@schluesseldienst-in-kiel.de")}</p>
              <br />
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
              <br />
              <p>{t("Haftung für Inhalte")}</p>
              <br />
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
                als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                rechtswidrige Tätigkeit hinweisen.
              </p>
              <br />
              <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
                jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
                umgehend entfernen.
              </p>
              <br />
              <p>{t("Haftung für Links")}</p>
              <br />
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
                keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
                Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
                Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
                Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
              <br />
              <p>
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
              <br />
              <p>{t("Urheberrecht")}</p>
              <br />
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
                Gebrauch gestattet.
              </p>
              <br />
              <p>
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
                gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam
                werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
                Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
              <br />
              <p>{t("Webdesign by Netzhirsch")}</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;
